import PipelineDetails from "../PipelineDetails/PipelineDetails";
import {closed} from "../PipelineDetails/PipelineDetails";
import {executeQuery} from "../../requests/executeQuery";
import {getData} from "../../requests/CRUD";
import {HSC_LOAN_QUOTES, PROPERTY_PAYMENT_TEAM, TEAM} from "../../consts/tables";
import {formatName} from "../../utils";
import {AGENT_COMMISSION_PAID, AGENT_COMMISSION_PROCURED} from "../../consts/queries";
import {GrossType} from "../../consts/consts";
import filter from "../../filter";
import { browserHistory } from "react-router";
import { getCurrentAccess } from "../../access";
import { isOwnCommissionOnly } from "../../access-levels";

const findIndex = require('lodash.findindex');
function compareDates(a,b){
    const dateA = new Date(a.CLOSE_OF_ESCROW);
    const dateB = new Date(b.CLOSE_OF_ESCROW);
    return dateA - dateB;
}
export default class AgentCommissionDetails extends PipelineDetails {
    constructor(props) {
        super(props);

        this.state = {
            tables: {
                [closed]: {
                    name: 'Closed',
                    data: [],
                    total: {},
                },
            },
            agentName: '',
            grossType: '',
            loading: true,
            query: {
                DATE: '',
                AGENT_ID: '',
                AGENT_NAME:'',
            },
            agentOptions: [],
        }
        this.fetchAgentOptions = this.fetchAgentOptions.bind(this);
    }

    componentDidUpdate(prevProps,prevState){
        const { location: {pathname,state}, routeParams:{id,year} } = this.props;
        if(pathname.match(/(paid|procured)/)){
            if(prevState.query.DATE!==year && prevState.query.AGENT_ID!==id){
                this.setState({query:{DATE: year,AGENT_ID:id}})
            }

            if(state && state.paidProcuredonSubmit){
                const pathnameArray = this.props.location && this.props.location.pathname ? this.props.location.pathname.split('/') : [];
                const grossType = this.state.query.AGENT_NAME ? (this.state.query.AGENT_NAME) : (pathnameArray && pathnameArray.length ? pathnameArray[pathnameArray.length - 1] : (this.props.grossType ? this.props.grossType : this.props.params.grossType));
                browserHistory.replace({pathname: window.location.pathname, state:null})
                grossType === 'paid' ? this.fetchPaid(id, year, grossType) : this.fetch(id, year, grossType);           
            }

           
        }
    }

    static convertData(dataToConvert, id) {
        const data = [];
        let arcRowId;        
        const stringId = String(id);

        dataToConvert.forEach(property => {
            if (arcRowId && property.ARCIMEDES_ROW_ID === arcRowId) {
                const index = data.length - 1;
                if (String(property.MEMBER_ID) !== stringId) {
                    data[index].ADDITIONAL_AGENTS = `${data[index].ADDITIONAL_AGENTS}${data[index].ADDITIONAL_AGENTS ? ', ' : ''}${formatName(property, '')}`;
                } else {
                    data[index].PERCENTAGE = property.PERCENTAGE;
                    data[index].TEAM_MEMBER_GROSS_FEE = property.TEAM_MEMBER_GROSS_FEE;
                    data[index].LISTING_GROSS_COMMISSION = property.LISTING_GROSS_COMMISSION;
                    if((property.BUYER_AGENT_1!==null && property.BUYER_AGENT_2===null && property.BUYER_AGENT_3===null)||
                    (property.BUYER_AGENT_1===null && property.BUYER_AGENT_2!==null && property.BUYER_AGENT_3===null)||
                    (property.BUYER_AGENT_1===null && property.BUYER_AGENT_2===null && property.BUYER_AGENT_3!==null)){
                        data[index].BUYING_GROSS_COMMISSION = 2*property.BUYING_GROSS_COMMISSION;
                    }else{
                        data[index].BUYING_GROSS_COMMISSION = property.BUYING_GROSS_COMMISSION;
                    }                    
                }
            } else {
                const index = findIndex(dataToConvert, item => item.ARCIMEDES_ROW_ID === property.ARCIMEDES_ROW_ID && String(item.MEMBER_ID) === stringId);
                if (index !== -1) {
                    arcRowId = property.ARCIMEDES_ROW_ID;
                    data.push({
                        ...property,
                        PERCENTAGE: String(property.MEMBER_ID) === stringId ? property.PERCENTAGE : '',
                        TEAM_MEMBER_GROSS_FEE: String(property.MEMBER_ID) === stringId ? property.TEAM_MEMBER_GROSS_FEE : '',
                        LISTING_GROSS_COMMISSION: String(property.MEMBER_ID) === stringId ? property.LISTING_GROSS_COMMISSION : '',
                        BUYING_GROSS_COMMISSION: String(property.MEMBER_ID) === stringId ? property.BUYING_GROSS_COMMISSION : '',
                        ADDITIONAL_AGENTS: String(property.MEMBER_ID) !== stringId ? formatName(property, '') : '',
                        PROCURED: property.BUYER_AGENT_1 != null && String(property.BUYER_AGENT_1) === stringId ? true
                            : property.BUYER_AGENT_2 != null && String(property.BUYER_AGENT_2) === stringId ? true
                                : property.BUYER_AGENT_3 != null && String(property.BUYER_AGENT_3) === stringId ? true
                                    : property.LISTING_AGENT_1 != null && String(property.LISTING_AGENT_1) === stringId ? true
                                        : property.LISTING_AGENT_2 != null && String(property.LISTING_AGENT_2) === stringId ? true
                                            : property.LISTING_AGENT_3 != null && String(property.LISTING_AGENT_3) === stringId ? true
                                                : false,
                    });
                }
            }
        });

        return data;
    }

    /** Their access level gives them only their own paid and procured figures (summit.commission = own). */
    isOwnOnly() {
        return isOwnCommissionOnly(getCurrentAccess()) && !!(this.props.userData && this.props.userData.id);
    }

    /** The agent to load: the one asked for, or the signed-in agent when they may see only their own. */
    scopeAgentId(id) {
        return this.isOwnOnly() ? String(this.props.userData.id) : id;
    }

    fetchAgentOptions() {
        const teamOptions = {
            column: ['ARCIMEDES_ROW_ID', 'FIRST_NAME', 'LAST_NAME', 'DELETED', 'IS_AGENT'],
            filter: [
                { text: 'n', code: 'DELETED', type: 'exact' },
                { text: 'a', code: 'IS_AGENT', type: 'exact' },
            ],
            filterType: 'and',
            order: [{ code: 'FIRST_NAME', type: 'asc' }, { code: 'LAST_NAME', type: 'asc' }],
        };
        getData({ tableCode: TEAM, options: teamOptions }).then(res => {
            let agentOptions = res && res.success && Array.isArray(res.data) ? res.data : [];
            if (this.isOwnOnly()) {
                const ownId = String(this.props.userData.id);
                agentOptions = agentOptions.filter((agent) => String(agent.ARCIMEDES_ROW_ID) === ownId);
            }
            this.setState({ agentOptions });
        });
    }

    componentDidMount() {
        const id = this.props.location && this.props.location.state && this.props.location.state.id ? this.props.location.state.id :
            (this.props.id ? this.props.id : this.props.params.id);
        const year = this.props.location && this.props.location.state && this.props.location.state.year ? this.props.location.state.year :
            (this.props.year ? this.props.year : this.props.params.year);

        const pathnameArray = this.props.location && this.props.location.pathname ? this.props.location.pathname.split('/') : [];
        const grossType = pathnameArray && pathnameArray.length ? pathnameArray[pathnameArray.length - 1] :
            (this.props.grossType ? this.props.grossType : this.props.params.grossType);

        this.fetchAgentOptions();

        if (id && grossType) {
            grossType === 'paid' ? this.fetchPaid(id, year, grossType) : this.fetch(id, year, grossType);
            return;
        }
        this.setState({loading: false});
    }
    async fetchPaid(id, year, grossType) {  
        id = this.scopeAgentId(id);
        let teamOptions = {};
        let q = {
            AGENT_ID: id,
            YEAR: year,
            order:'CLOSE_OF_ESCROW.asc'
        }
        const options = filter(q, 'agent-commission');
        // The name handed over with the link may be someone else's when the id was scoped.
        let agentName = this.isOwnOnly() ? null : (this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name);
        if (!agentName) {
            teamOptions = {
                column: [
                    'FIRST_NAME',
                    'LAST_NAME',
                ],
                filter: [{
                    'text': id,
                    'code': 'ARCIMEDES_ROW_ID',
                    'type': 'exact',
                }],
            };
        }
        Promise.all([
            executeQuery({ queryName: AGENT_COMMISSION_PROCURED, options }), 
            executeQuery({ queryName: AGENT_COMMISSION_PAID, options }),
            getData({tableCode: TEAM, options: teamOptions}),
        ]).then(async res => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                res[1] && res[1].success && Array.isArray(res[1].data) &&
                res[2] && res[2].success && Array.isArray(res[2].data)) {
                
                let map = new Map();
                res[0].data.forEach(item =>{ 
                    map.set(item.ARCIMEDES_ROW_ID, item)
                });                

                const tables = {...this.state.tables};
                const data = grossType === GrossType.Paid ? AgentCommissionDetails.convertData(res[1].data, id) : res[1].data;
                const status = grossType ? grossType.charAt(0).toUpperCase() + grossType.slice(1) : '';
                tables[closed].name = `Closed - ${status}`;
                data.forEach((item,index )=> {
                    if (map.has(item.ARCIMEDES_ROW_ID)) {
                        let listingGrossCommission = map.get(item.ARCIMEDES_ROW_ID).LISTING_GROSS_COMMISSION;
                        let buyingGrossCommission = map.get(item.ARCIMEDES_ROW_ID).BUYING_GROSS_COMMISSION;
                        map.set(item.ARCIMEDES_ROW_ID, {...data[index], listingGrossCommission,buyingGrossCommission});
                    } else {
                        map.set(item.ARCIMEDES_ROW_ID, item);
                    }
                });
                const mergedArray =  Array.from(map.values()); 
                mergedArray.sort(compareDates);
                tables[closed] = AgentCommissionDetails.buildTable(closed, tables[closed], mergedArray, grossType,id);
                    if (res[2])
                    agentName = formatName(res[2].data[0]);

                this.setState({
                    agentName,
                    tables,
                    grossType
                });         
                
                tables[closed].data.forEach(async (item)=>{
                const findData = await this.getPropertyPayments(item.ID)
                if(findData && findData.length){
                    const fetchpropertyData = findData.find((item)=> String(item.STRIVE_TEAM_MEMBER_ID)===String(id))

                    if(fetchpropertyData){
                        item.PERCENTAGE = fetchpropertyData.STRIVE_TEAM_MEMBER_PERCENT  ? `${parseFloat(fetchpropertyData.STRIVE_TEAM_MEMBER_PERCENT).toFixed(2)}%` : '0.00%';
                        // Extra Payment's gross paid (REFERRAL_FEE x share) is set in buildTable;
                        // its payment-team gross fee is 0/stale, so don't overwrite it with 0.
                        if (item.TRANSACTION_TYPE !== 'Extra Payment') {
                            item.GROSS_FEE = fetchpropertyData.STRIVE_TEAM_MEMBER_GROSS_FEE ? parseFloat(fetchpropertyData.STRIVE_TEAM_MEMBER_GROSS_FEE) :0;
                        }
                        this.setState({tables})
                    }
                }
                })
            }
            this.setState({loading: false});
        });
    }

     async getPropertyPayments(propertyId='') {
        try {
            const res = await getData({
                tableCode: PROPERTY_PAYMENT_TEAM,
                columns: [
                    'ARCIMEDES_ROW_ID',
                    'PROPERTY_ID',
                    'STRIVE_TEAM_MEMBER_ID',
                    'STRIVE_TEAM_MEMBER_PERCENT',
                    'STRIVE_TEAM_MEMBER_GROSS_FEE',
                    'STRIVE_TEAM_MEMBER_NET_FEE',
                    'STRIVE_TEAM_MEMBER_NET_PERCENT'
                ],
                options: {
                    filter: [
                        {
                            text: propertyId,
                            code: 'PROPERTY_ID',
                            type: 'exact',
                        },
                    ]
                },
            })
            const result = res && res.data.length && res.data;
            return result;
        } catch (error) {
            throw error; 
        }
    }

    fetch(id, year, grossType) {
        id = this.scopeAgentId(id);
        let queryName = '';
        let q = {};
        switch (grossType) {
            case GrossType.Procured:
                queryName = AGENT_COMMISSION_PROCURED;
                q = {
                    AGENT_ID: id,
                    YEAR: year,
                    order:'CLOSE_OF_ESCROW.asc'
                }
                break;
            case GrossType.Paid:
                queryName = AGENT_COMMISSION_PAID;
                q = {
                    YEAR: year,
                    order:'CLOSE_OF_ESCROW.asc'
                }
                break;
        }
        const options = filter(q, 'agent-commission');

        const requests = [
            executeQuery({queryName, options})
        ];

        // The name handed over with the link may be someone else's when the id was scoped.
        let agentName = this.isOwnOnly() ? null : (this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name);
        if (!agentName) {
            const options = {
                column: [
                    'FIRST_NAME',
                    'LAST_NAME',
                ],
                filter: [{
                    'text': id,
                    'code': 'ARCIMEDES_ROW_ID',
                    'type': 'exact',
                }],
            };
            requests.push(getData({tableCode: TEAM, options}));
        }

        Promise.all(requests).then(res => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                (!res[1] || res[1] && res[1].success && Array.isArray(res[1].data))) {
                const tables = {...this.state.tables};
                res[0].data = res[0].data.filter(property => property.TRANSACTION_TYPE !== "Extra Payment");
                const data = grossType === GrossType.Paid ? AgentCommissionDetails.convertData(res[0].data, id) : res[0].data;
                const status = grossType ? grossType.charAt(0).toUpperCase() + grossType.slice(1) : '';
                tables[closed].name = `Closed - ${status}`;
                tables[closed] = AgentCommissionDetails.buildTable(closed, tables[closed], data, grossType,id);
                if (res[1])
                    agentName = formatName(res[1].data[0]);

                this.setState({
                    agentName,
                    tables,
                    grossType
                });

                /*  tables[closed].data.forEach(async (item)=>{
                const findData = await this.getPropertyPayments(item.ID)
                if(findData && findData.length){
                    const fetchpropertyData = findData.find((item)=> String(item.STRIVE_TEAM_MEMBER_ID)===String(id))
                  
                    if(fetchpropertyData){
                        item.NET_FEE = parseFloat(fetchpropertyData.STRIVE_TEAM_MEMBER_NET_FEE)
                        item.NET_PERCENT = fetchpropertyData.STRIVE_TEAM_MEMBER_PERCENT  ? `${parseFloat(fetchpropertyData.STRIVE_TEAM_MEMBER_PERCENT).toFixed(2)}%` : '0.00%';
                        this.setState({tables})
                    }
                }

                }) */
            }
            this.setState({loading: false});
        });
    }
}